import React, { Component } from 'react';
import { connect } from 'react-redux';
import { has } from 'lodash';

import ActionButtonRow from 'components/inbox/ActionButtonRow';

import * as UncontrolledSwitch from '@klarna/ui/uncontrolled/Switch';

const STYLE = {
  toggle: {
    zIndex: 99,
  },
};

class OverrideConflicts extends Component {
  render() {
    const { event, allowOverride } = this.props;
    let { conflicts } = this.props;

    if (has(conflicts, 'conflicts')) {
      conflicts = conflicts.conflicts;
    }

    if (!conflicts || !conflicts.length) {
      return null;
    }

    const { action } = this.props.conflicts;

    return (
      <div className="event-conflicts">
        <h2>Conflicts</h2>
        {conflicts.map((conflict, i) => (
          <div key={`conflict${i}`}>
            <h4>{conflict.title} ({conflict.num_conflicts})</h4>
            <ul>
              {conflict.objects && conflict.objects.map(item => (
                <li key={`conflictItem${item.id}`}>
                  <span dangerouslySetInnerHTML={{ __html: item.name }} />
                  {item.events && item.events.map(itemEvent => (
                    <div className="conflict-context" key={`conflictEventContext${itemEvent.id}${item.id}`}>
                      Event: <span dangerouslySetInnerHTML={{ __html: itemEvent.name }} /> {itemEvent.conflict_range}
                    </div>
                  ))}
                </li>
              ))}
            </ul>
          </div>
        ))}

        {allowOverride && (
          <UncontrolledSwitch.Toggle
            name="override_conflicts"
            value={false}
            style={STYLE.toggle}
            onChange={(isChecked) => {
              if (this.props.onConflictOverride) {
                this.props.onConflictOverride(isChecked);
              }
            }}
          >Override Conflicts</UncontrolledSwitch.Toggle>
        )}

        {action && (
          <ActionButtonRow actions={action} event={event} includeReason />
        )}
      </div>
    );
  }
}

function mapStateToProps(/* state */) {
  // const { inbox } = state;
  // const { events, isLoading } = inbox;

  return {
    // isLoading,
    // events,
  };
}

export default connect(mapStateToProps, {

})(OverrideConflicts);



// WEBPACK FOOTER //
// ./src/app/components/inbox/OverrideConflicts.js